export const InfoItem = ({ label, value }) => (
  <div className='flex flex-col space-y-1'>
    <span className='text-[10px] md:text-[11px] font-medium text-slate-400/80 tracking-tight'>
      {label}
    </span>
    <div className='text-[13px] md:text-[14px] font-semibold text-slate-700 leading-relaxed break-words'>
      {value || <span className='text-slate-300 font-normal italic'>No especificado</span>}
    </div>
  </div>
)

export default function TabDatosCliente({ receiver }) {
  const fields = [
    { key: 'business_name', label: 'Razón social' },
    { key: 'rut', label: 'RUT' },
    { key: 'address', label: 'Dirección' },
    { key: 'business_activity', label: 'Actividad económica' },
    { key: 'district', label: 'Comuna' },
    { key: 'city', label: 'Ciudad' }
  ]

  return (
    <div className='mt-2 p-1'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-2 py-4 px-2'>
        {fields.map(f => (
          <InfoItem
            key={f.key}
            label={f.label}
            value={receiver[f.key]}
          />
        ))}
      </div>
    </div>
  )
}
